import { useEffect, useState } from 'react';
import { useBasicInfo } from '@/components/_shared/contexts/BasicInfoContext';
import { useSalesStatus } from '@/components/_shared/contexts/SalesStatusContext';
import { useTicketInformation } from '@/hooks/useTicketInformation/useTicketInformation';
import { QUERY_PARAMS } from '../../../../common/constants';
import { shouldDisplayRsvp as computeShouldDisplayRsvp } from '../utils';
import { HAS_WINDOW } from '@eventbrite/feature-detection';
import { isCampaignTokenValid } from '../RSVP/rsvpApiClient';

export interface RsvpParamsState {
  mipaToken: string | null;
}

export const useShouldDisplayRsvp = () => {
  const [rsvpParams, setUrlParams] = useState<RsvpParamsState>({
    mipaToken: null,
  });

  const { id: eventId, status } = useBasicInfo();
  const { displayStatus } = useSalesStatus();
  const [ticketInfo] = useTicketInformation();

  useEffect(() => {
    const verifyMipaToken = async () => {
      if (!HAS_WINDOW) return;
      const params = new URLSearchParams(window.location.search);
      const mipaToken = params.get(QUERY_PARAMS.MIPA);

      if (!mipaToken) {
        return;
      }

      const isMipaTokenValid = await isCampaignTokenValid(eventId, mipaToken);
      if (isMipaTokenValid) {
        setUrlParams({
          mipaToken: mipaToken,
        });
      }
    };
    verifyMipaToken();
  }, [eventId]);

  const shouldDisplayRsvp = computeShouldDisplayRsvp(rsvpParams.mipaToken, status, displayStatus, ticketInfo);

  return {
    shouldDisplayRsvp,
    mipaToken: rsvpParams.mipaToken,
  };
};
